import { useState, FC } from 'react';
import { ChakraConfirmationDialog } from 'app/components/Dialogs';
import { Audio } from 'types/audio';

interface MarkPublicAudioDialogProps {
  onClose: () => void;
  audio?: Audio;
  onConfirm: (audio: Audio) => Promise<any>;
}

export const MarkPublicAudioDialog: FC<MarkPublicAudioDialogProps> = ({
  onClose,
  onConfirm,
  audio,
}) => {
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    if (audio) {
      try {
        setLoading(true);
        await onConfirm(audio);
        onClose();
      } catch (e) {
        // proceed regardless
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <ChakraConfirmationDialog
      isOpen
      title="Set to Private?"
      disableSubmitAction={loading}
      handleAction={onSubmit}
      onClose={onClose}
      actionButtonText="Set"
      message={`Are you sure you want to set "${audio?.title}" to Private? It will also be unmarked as Latest version.`}
    />
  );
};
